import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
	IState,
	legalHoldAdapter,
	legalHoldFeatureKey,
} from './legal-hold.reducers';
import { createQueryParamsWithPagination } from '../../../shared/utils';
import { ILegalHoldFilter } from './legal-hold.interface';

const selectFeature = createFeatureSelector<IState>(legalHoldFeatureKey);

const { selectAll } = legalHoldAdapter.getSelectors(selectFeature);

const selectError = createSelector(selectFeature, (state) => state.error);

const selectLoading = createSelector(selectFeature, (state) => state.loading);

const selectHoldFilter = createSelector(selectFeature, (state) => state.filter);

const selectHoldFilterRequest = createSelector(selectHoldFilter, (state) =>
	createQueryParamsWithPagination<ILegalHoldFilter>(state),
);

const selectSelectedHold = createSelector(
	selectFeature,
	(state) => state.selectedHold,
);

const selectSocketConnected = createSelector(
	selectFeature,
	(state) => state.socketConnected,
);

const selectIdentitySnapshot = createSelector(
	selectFeature,
	(state) => state.identitySnapshot,
);

export const LegalHoldSelectors = {
	selectAll,
	selectError,
	selectLoading,
	selectHoldFilter,
	selectHoldFilterRequest,
	selectSelectedHold,
	selectSocketConnected,
	selectIdentitySnapshot,
};
